<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Store"
              bc1="App"
              bc2="Onboard"
              bc3="Update"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section v-show="showBusinessForm"  id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Merchant Store Manual Verification</h4>
                </div>
                <div class="card-body">
                  <div class="row mb-2">
                     <div class="col-12">
                       <span class="text-dark font-weight-bolder font-small-3">Parent ID: <span
                           class="text-primary badge badge-light-primary font-small-2">{{ row?.parent_entity }}</span> </span>
                       <span class="text-dark font-weight-bolder font-small-3 ml-sm-1">Reference: <span
                           class="text-primary badge badge-light-success font-small-2">{{ row?.reference }}</span></span>
                     </div>
                  </div>
                  <form class="form form-horizontal" >
                    <div class="row">
                      <div class="col-4">
                        <div class="form-group ">
                          <label>Registered Country</label>
                          <select v-model="country" class="form-control" >
                            <option value>Select Country</option>
                            <option value="UAE">United Arab Emirates</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Business Type </label>
                          <div class="">
                            <div class="mt-1">
                              <div class="custom-control custom-radio" >
                                <input type="radio" id="customRadio1" v-model="type" name="businessType" class="custom-control-input" value="1"  >
                                <label class="custom-control-label" for="customRadio1">Sole Trader</label>
                              </div>
                            </div>
                            <div class="mt-1">
                              <div class="custom-control custom-radio">
                                <input type="radio" id="customRadio2" v-model="type" name="businessType" class="custom-control-input" value="2" >
                                <label class="custom-control-label" for="customRadio2">Registered Business</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section  id="page-account-settings">
          <div class="row">
            <!-- left menu section -->
            <div class="col-md-3 mb-2 mb-md-0">
              <ul class="nav nav-pills flex-column nav-left">
                <!-- general -->
                <li class="nav-item">
                  <a class="nav-link active" @click="showBusinessForm = true"  id="account-pill-general" data-toggle="pill" href="#account-vertical-general" aria-expanded="true">
                    <i data-feather="user" class="font-medium-3 mr-1"></i>
                    <span class="font-weight-bold">Business Details</span>
                  </a>
                </li>
                <li class="nav-item" @click="showBusinessForm = false">
                  <a class="nav-link"  id="account-pill-password" data-toggle="pill" href="#account-vertical-password" aria-expanded="false">
                    <i data-feather="lock" class="font-medium-3 mr-1"></i>
                    <span class="font-weight-bold">Business Owner</span>
                  </a>
                </li>
              </ul>
            </div>
            <!--/ left menu section -->

            <!-- right content section -->
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="tab-content">
                    <!-- general tab -->
                    <div role="tabpanel" class="tab-pane active" id="account-vertical-general" aria-labelledby="account-pill-general" aria-expanded="true">


                      <!-- form -->
                      <form class="validate-form mt-2">
                        <div class="row">
                          <div class="col-12">
                            <div class="d-flex align-items-center mb-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                   fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                   stroke-linejoin="round" class="feather feather-link font-medium-3">
                                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                              </svg>
                              <h4 class="mb-0 ml-75">Business details</h4>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <p class="text-muted ">Information about your business that we use to keep your account safe and to comply with financial regulations.</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label class="form-label">Name</label>
                              <input type="text" v-model="name" name="tradingName"  class="form-control"  />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-name">Business Phone Number</label>
                              <input type="text" v-model="phone" name="phone"  class="form-control"  />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-e-mail">Business Email</label>
                              <input type="email" v-model="email" name="email"  class="form-control"  />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-e-mail">MCC</label>
                              <select v-model="mcc" name="mcc"  class="form-control">
                                <option v-for="category in categories" :key="category.code" :value="category.code">
                                  {{ category.code }} – {{ category.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </form>

                      <div class="card bg-light mt-2">
                        <div class="card-header">
                          <h4 class="card-title">Registered business address</h4>
                        </div>
                        <div class="card-body">
                          <form class="validate-form mt-2">
                            <div class="row">
                              <div class="col-12">
                                <div class="form-group">
                                  <label for="account-name">Address Line 1</label>
                                  <input type="text" v-model="addressLine1" name="addressLine1"  class="form-control"  />
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="form-group">
                                  <label for="account-name">Address Line 2</label>
                                  <input type="text" v-model="addressLine2" name="addressLine2"  class="form-control"  />
                                </div>
                              </div>
                              <div class="col-12 col-sm-6">
                                <div class="form-group">
                                  <label for="account-e-mail">City or town</label>
                                  <input type="text" v-model="city" name="city"  class="form-control"  />
                                </div>
                              </div>
                              <div class="col-12 col-sm-6">
                                <div class="form-group">
                                  <label for="account-e-mail">Post Code</label>
                                  <input type="text" v-model="postalCode" name="postalCode"  class="form-control"  />
                                </div>
                              </div>
                              <div class="col-12 col-sm-6">
                                <div class="form-group">
                                  <label for="account-e-mail">Website</label>
                                  <input type="text" v-model="website" name="website"  class="form-control"  />
                                </div>
                              </div>

                            </div>
                          </form>
                        </div>
                      </div>

<!--                      <div class="row">-->
<!--                        <div class="col-12">-->
<!--                          <button type="button" class="btn btn-primary mt-1 mr-1" @click="submitAllForms">Update</button>-->
<!--                        </div>-->
<!--                      </div>-->

                    </div>
                    <div class="tab-pane fade" id="account-vertical-password" role="tabpanel" aria-labelledby="account-pill-password" aria-expanded="false">
                      <div class="row">
                        <div class="col-8">
                          <div class="d-flex align-items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" class="feather feather-link font-medium-3">
                              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                            </svg>
                            <h4 class="mb-0 ml-75">Business owner</h4>
                          </div>
                        </div>
<!--                        <div class="col-4 d-flex justify-content-end">-->
<!--                          <button class="btn btn-sm btn-primary" style="height: 70%" @click="addOwnerRow">Add</button>-->
<!--                        </div>-->
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <p class="text-muted ">Information about the individual who owns the business.</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 p-0">
                          <div class="card ">
                            <div class="card-body p-0">
                              <div id="accordionWrapa50" role="tablist" aria-multiselectable="true">
                                <div class="card collapse-icon">

                                  <div class="card-body">
                                    <div class="collapse-border aaa" id="accordionExample0">
                                      <div class="card" v-for="(owner, index) in ownerRowList" :key="index">
                                        <div
                                            class="card-header collapsed"
                                            :id="'heading' + owner.rowIdentifier"
                                            data-toggle="collapse"
                                            role="button"
                                            :data-target="'#collapse' + owner.rowIdentifier"
                                            aria-expanded="false"
                                            :aria-controls="'collapse' + owner.rowIdentifier"
                                        >
                                          <span class="lead collapse-title">Owner {{ index + 1 }}</span>
<!--                                          <button-->
<!--                                              type="button"-->
<!--                                              class="btn btn-danger btn-sm"-->
<!--                                              @click.stop="deleteOwnerRow(owner,index)"-->
<!--                                          >-->
<!--                                            Delete-->
<!--                                          </button>-->
                                        </div>

                                        <!-- Collapsible Content -->
                                        <div
                                            :id="'collapse' + owner.rowIdentifier"
                                            class="collapse"
                                            :aria-labelledby="'heading' + owner.rowIdentifier"
                                            data-parent="#accordionExample0"
                                        >
                                          <div class="card-body">
                                            <div class="row">
                                              <!-- Owner Details -->
                                              <div class="col-12">
                                                <form class="validate-form">
                                                  <div class="row">
                                                    <div class="col-6">
                                                      <div class="form-group">
                                                        <label for="first-name">First Name</label>
                                                        <input
                                                            type="text"
                                                            v-model="owner.firstName"
                                                            class="form-control"
                                                            placeholder="First Name"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div class="col-6">
                                                      <div class="form-group">
                                                        <label for="last-name">Last Name</label>
                                                        <input
                                                            type="text"
                                                            v-model="owner.lastName"
                                                            class="form-control"
                                                            placeholder="Last Name"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div class="col-12">
                                                      <div class="form-group">
                                                        <label for="dob" class="d-flex">Date of Birth</label>
                                                        <date-picker
                                                            v-model="owner.dob"
                                                            :disabledDate="disableFutureDates"
                                                            valueType="format"
                                                            :lang="lang"
                                                            placeholder="select date"
                                                        ></date-picker>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </form>
                                              </div>

                                              <!-- Divider -->
                                              <div class="col-12">
                                                <hr class="my-2" />
                                              </div>

                                              <!-- Proof of Identity Section -->
                                              <div class="col-12">
                                                <div class="d-flex align-items-center">
                                                  <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="14"
                                                      height="14"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      stroke-width="2"
                                                      stroke-linecap="round"
                                                      stroke-linejoin="round"
                                                      class="feather feather-user font-medium-3"
                                                  >
                                                    <path
                                                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                                    ></path>
                                                    <circle cx="12" cy="7" r="4"></circle>
                                                  </svg>
                                                  <h4 class="mt-2 mb-2 ml-75">Proof of Identity</h4>
                                                </div>
                                                <div class="card">
                                                  <div class="card-body">
                                                    <form class="validate-form">
                                                      <div class="row">
                                                        <!-- Warning -->
                                                        <div class="col-12">
                                                          <div
                                                              class="alert alert-warning mt-1 mb-1 alert-validation-msg"
                                                              role="alert"
                                                          >
                                                            <div class="alert-body">
                                                              <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  width="14"
                                                                  height="14"
                                                                  viewBox="0 0 24 24"
                                                                  fill="none"
                                                                  stroke="currentColor"
                                                                  stroke-width="2"
                                                                  stroke-linecap="round"
                                                                  stroke-linejoin="round"
                                                                  class="feather feather-info mr-50 align-middle"
                                                              >
                                                                <circle cx="12" cy="12" r="10"></circle>
                                                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                                              </svg>
                                                              <span
                                                              >If we can’t <strong>verify</strong> this person
                                using the details provided, we’ll need to
                                request proof of identity.</span
                                                              >
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <!-- ID Type Selection -->
                                                        <div class="col-12">
                                                          <div class="form-group">
                                                            <label for="id-type">Select Document Type</label>
                                                            <select
                                                                v-model="owner.idType"
                                                                class="form-control"
                                                            >
                                                              <option value="passport">Passport</option>
                                                              <option value="drivingLicense">
                                                                Driving License
                                                              </option>
                                                              <option value="nationalIdCard">National ID</option>
                                                              <option value="residencePermit">
                                                                Residence Permit
                                                              </option>
                                                              <option value="tradeLicense">
                                                                Trade License
                                                              </option>
                                                              <option value="mou">
                                                                MOU
                                                              </option>
                                                            </select>
                                                          </div>
                                                        </div>

                                                        <!-- ID Document Requirements -->
                                                        <div class="col-12">
                                                          <section id="accordion-with-shadow">
                                                            <div class="row">
                                                              <div class="col-sm-12">
                                                                <div
                                                                    id="accordionWrapa10"
                                                                    role="tablist"
                                                                    aria-multiselectable="true"
                                                                >
                                                                  <div class="card collapse-icon">
                                                                    <div class="card-header">
                                                                      <h4 class="card-title">
                                                                        ID Document Requirements
                                                                      </h4>
                                                                    </div>
                                                                    <div class="card-body">
                                                                      <div
                                                                          class="collapse-shadow border-secondary badge-glow"
                                                                      >
                                                                        <div>
                                                                          <div
                                                                              id="heading11"
                                                                              class="card-header"
                                                                              data-toggle="collapse"
                                                                              role="button"
                                                                              data-target="#accordion10"
                                                                              aria-expanded="false"
                                                                              aria-controls="accordion10"
                                                                          >
                                            <span class="lead collapse-title">
                                              Requirement For
                                              {{ formatStringInHumanReadable(owner.idType) }}
                                            </span>
                                                                          </div>
                                                                          <div
                                                                              id="accordion10"
                                                                              role="tabpanel"
                                                                              data-parent="#accordionWrapa10"
                                                                              aria-labelledby="heading11"
                                                                              class="collapse"
                                                                          >
                                                                            <div class="card-body">
                                                                              <div class="row">
                                                                                <div class="col-12 text-center">
                                                                                  <img style="width: 40%" src="https://kycscreen.com/wp-content/uploads/2020/03/services-1.png" />
                                                                                </div>
                                                                              </div>
                                                                              <ul>
                                                                                <li>
                                                                                  Must be a colored original
                                                                                  scan or photo of the document
                                                                                </li>
                                                                                <li>
                                                                                  Must be completely visible,
                                                                                  with all four corners within
                                                                                  the scan or photo
                                                                                </li>
                                                                                <li>
                                                                                  File format can be JPEG, PNG,
                                                                                  or PDF, 4MB max
                                                                                </li>
                                                                                <li>
                                                                                  The following will not be
                                                                                  accepted:
                                                                                  <ul>
                                                                                    <li>
                                                                                      Expired, blurry, or
                                                                                      trimmed document
                                                                                    </li>
                                                                                    <li>
                                                                                      Black and white document
                                                                                    </li>
                                                                                    <li>
                                                                                      Photo of a screen or
                                                                                      another photo
                                                                                    </li>
                                                                                    <li>
                                                                                      Provisional document, e.g.,
                                                                                      provisional driving license
                                                                                    </li>
                                                                                  </ul>
                                                                                </li>
                                                                              </ul>
                                                                              <div class="form-group mt-2">
                                                                                <div class="row">
                                                                                  <div class="col-12">
                                                                                    <label for="upload-document">
                                                                                      Uploaded Document
                                                                                    </label>
                                                                                  </div>
                                                                                </div>
                                                                                <div class="row" v-show="owner.doc_url">
                                                                                  <div class="mb-1 mt-1">
                                                                                    <img width="300"     class="preview-image" @click="showPreviewModal = true"  :src="owner.doc_url"  />
                                                                                  </div>

                                                                                  <div v-if="showPreviewModal" class="fullscreen-modal" @click="showPreviewModal = false">
                                                                                    <img :src="owner.doc_url" class="fullscreen-image" alt="Enlarged Image" />
                                                                                  </div>
                                                                                  <div v-if="showPreviewModal" class="modal-backdrop fade show"></div>
                                                                                </div>
<!--                                                                                <div class="row">-->
<!--                                                                                  <div class="col-12">-->
<!--                                                                                    <input-->
<!--                                                                                        type="file"-->
<!--                                                                                        @change="handleFileUpload($event, owner)"-->
<!--                                                                                        class="d-block"-->
<!--                                                                                    />-->
<!--                                                                                  </div>-->
<!--                                                                                </div>-->


                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </section>
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-12 text-right">
<!--                                                <button-->
<!--                                                    class="btn btn-primary mt-3"-->
<!--                                                    @click="submitOwner(owner, index)"-->
<!--                                                >-->
<!--                                                  {{owner.status == 'add' ? 'Submit' : 'Update'}} Owner {{ index + 1 }}-->
<!--                                                </button>-->
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
<!--                                    <div class="row">-->
<!--                                      <div class="col-12 text-right">-->
<!--                                        <button v-show="ownerRowList.length > 0" class="btn btn-primary mt-3" @click="submitForApproval">Submit for Approval</button>-->
<!--                                      </div>-->
<!--                                    </div>-->
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to remove this owner?"
                           title="Delete Owner"
                           @hide="denied"></ConfirmationModal>

      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  components:{
    DatePicker
  },
  mounted() {
    this.row = this.$store.getters.getByKey(
        "merchantStoreActivation"
    )?.row;


    if(!this.row) {
      this.$router.push({name: 'store'})
      return
    }

    this.storeId = this.row.id
    this.dob = this.row.dob
    this.type = this.row.type
    this.addressLine1 = this.row.address?.addressline1
    this.addressLine2 = this.row.address?.addressline2
    this.country = this.row.address?.country
    this.city = this.row.address?.city
    this.state = this.row.address?.state
    this.postalCode = this.row.address?.postCode
    this.name = this.row.name
    this.phone = this.row.phone
    this.email = this.row.email
    this.mcc = this.row.mcc_code
    this.website = this.row.website
    this.parentEntity = this.row.parent_entity
    this.reference = this.row.reference

    this.row?.owners?.forEach(owner => {
      this.ownerRowList.push({
        rowIdentifier: `owner-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        id: owner.id,
        firstName: owner.first_name,
        lastName: owner.last_name,
        dob: owner.dob,
        idType: owner.documents.length ? owner.documents[0].type : '',
        doc_url: owner.documents.length ?  owner.docs_url+ owner.documents[0].attachment : '',
        status: 'update',
      });
    })
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Manage Store'},
        {name: 'Update'},
      ],
      categories: [
        { code: "0742", name: "Veterinary Services" },
        { code: "0763", name: "Agricultural Cooperatives" },
        { code: "1520", name: "General Contractors – Residential and Commercial" },
        { code: "1711", name: "Heating, Plumbing, and Air Conditioning Contractors" },
        { code: "1731", name: "Electrical Contractors" },
        { code: "1740", name: "Masonry, Stonework, Tile Setting, and Plastering Contractors" },
        { code: "1750", name: "Carpentry Contractors" },
        { code: "1761", name: "Roofing, Siding, and Sheet Metal Work Contractors" },
        { code: "1771", name: "Concrete Work Contractors" },
        { code: "1799", name: "Special Trade Contractors (Not Elsewhere Classified)" },
        { code: "2741", name: "Miscellaneous Publishing and Printing" },
        { code: "2791", name: "Typesetting, Plate Making, and Related Services" },
        { code: "2842", name: "Specialty Cleaning, Polishing, and Sanitation Preparations" },
        { code: "2893", name: "Industrial Gases" },
        { code: "3000–3299", name: "Air Carriers" },
        { code: "3351", name: "Iron and Steel Mills" },
        { code: "3357", name: "Rolling, Drawing, and Extruding of Nonferrous Metals" },
        { code: "3400–3999", name: "Industrial and Manufacturing Services" },
        { code: "4011", name: "Railroads" },
        { code: "4111", name: "Local/Suburban Commuter Transportation" },
        { code: "4112", name: "Passenger Railways" },
        { code: "4121", name: "Taxicabs and Limousines" },
        { code: "4131", name: "Bus Lines" },
        { code: "4214", name: "Motor Freight Carriers" },
        { code: "4215", name: "Courier Services" },
        { code: "4225", name: "Public Warehousing" },
        { code: "4411", name: "Cruise Lines" },
        { code: "4457", name: "Boat Rentals and Leases" },
        { code: "4468", name: "Marinas and Marine Services" },
        { code: "4511", name: "Airlines" },
        { code: "4582", name: "Airports, Airfields, and Flight Services" },
        { code: "4722", name: "Travel Agencies" },
        { code: "4812", name: "Telecommunications Equipment and Telephone Sales" },
        { code: "4814", name: "Telecommunication Services" },
        { code: "4899", name: "Cable, Satellite, and Other Pay Television Services" },
        { code: "4900", name: "Utilities" },
        { code: "5044", name: "Office and Commercial Furniture" },
        { code: "5045", name: "Computers, Peripherals, and Software" },
        { code: "5046", name: "Commercial Equipment" },
        { code: "5065", name: "Electrical Parts and Equipment" },
        { code: "5072", name: "Hardware Equipment and Supplies" },
        { code: "5074", name: "Plumbing and Heating Equipment" },
        { code: "5111", name: "Stationery and Office Supplies" },
        { code: "5122", name: "Drugs, Drug Proprietaries, and Druggist Sundries" },
        { code: "5192", name: "Books, Periodicals, and Newspapers" },
        { code: "5200", name: "Home Supply Warehouse Stores" },
        { code: "5211", name: "Lumber and Building Materials Stores" },
        { code: "5231", name: "Paint, Glass, and Wallpaper Stores" },
        { code: "5251", name: "Hardware Stores" },
        { code: "5261", name: "Nurseries and Garden Supply Stores" },
        { code: "5300", name: "Wholesale Clubs" },
        { code: "5310", name: "Discount Stores" },
        { code: "5311", name: "Department Stores" },
        { code: "5331", name: "Variety Stores" },
        { code: "5399", name: "Miscellaneous General Merchandise Stores" },
        { code: "5411", name: "Grocery Stores and Supermarkets" },
        { code: "5462", name: "Bakeries" },
        { code: "5499", name: "Miscellaneous Food Stores" },
        { code: "5511", name: "Car Dealers (New and Used)" },
        { code: "5521", name: "Car Dealers (Used Only)" },
        { code: "5532", name: "Automotive Tire Stores" },
        { code: "5533", name: "Automotive Parts and Accessories Stores" },
        { code: "5541", name: "Gas Stations" },
        { code: "5542", name: "Fuel Dispenser Merchants" },
        { code: "5561", name: "Recreational and Utility Trailers, Campers" },
        { code: "5571", name: "Motorcycle Shops" },
        { code: "5592", name: "Motor Home Dealers" },
        { code: "5598", name: "Snowmobile Dealers" },
        { code: "5611", name: "Men’s and Boy’s Clothing Stores" },
        { code: "5621", name: "Women’s Ready-to-Wear Stores" },
        { code: "5631", name: "Women’s Accessory and Specialty Shops" },
        { code: "5651", name: "Family Clothing Stores" },
        { code: "5661", name: "Shoe Stores" },
        { code: "5691", name: "Men’s and Women’s Clothing Stores" },
        { code: "5699", name: "Miscellaneous Apparel and Accessory Stores" },
        { code: "5712", name: "Furniture, Home Furnishings, and Equipment Stores" },
        { code: "5732", name: "Electronics Stores" },
        { code: "5733", name: "Music Stores (Instruments and Sheet Music)" },
        { code: "5734", name: "Computer Software Stores" },
        { code: "5811", name: "Caterers" },
        { code: "5812", name: "Eating Places and Restaurants" },
        { code: "5813", name: "Drinking Places (Alcoholic Beverages)" },
        { code: "5814", name: "Fast Food Restaurants" },
        { code: "5912", name: "Drug Stores and Pharmacies" },
        { code: "5921", name: "Liquor Stores" },
        { code: "5931", name: "Used Merchandise and Secondhand Stores" },
        { code: "5941", name: "Sporting Goods Stores" },
        { code: "5942", name: "Book Stores" },
        { code: "5943", name: "Office and School Supply Stores" },
        { code: "5944", name: "Jewelry Stores" },
        { code: "5945", name: "Hobby, Toy, and Game Stores" },
        { code: "5946", name: "Camera and Photographic Supply Stores" },
        { code: "5947", name: "Gift, Card, Novelty, and Souvenir Shops" },
        { code: "5948", name: "Luggage and Leather Goods Stores" },
        { code: "5949", name: "Sewing, Needlework, and Piece Goods Stores" },
        { code: "5960", name: "Direct Marketing – Insurance Services" },
        { code: "5961", name: "Mail Order Houses" },
        { code: "5962", name: "Direct Marketing – Travel-Related Arrangements" },
        { code: "5963", name: "Direct Marketing – Door-to-Door Sales" },
        { code: "5964", name: "Direct Marketing – Catalog Merchants" },
        { code: "5965", name: "Direct Marketing – Combination Catalog/Telephone" },
        { code: "5966", name: "Direct Marketing – Outbound Telemarketing" },
        { code: "5967", name: "Direct Marketing – Inbound Telemarketing" },
        { code: "5968", name: "Direct Marketing – Continuity/Subscription" },
        { code: "5969", name: "Direct Marketing – Other Services" },
        { code: "5971", name: "Art Dealers and Galleries" },
        { code: "5972", name: "Stamp and Coin Stores" },
        { code: "5973", name: "Religious Goods Stores" },
        { code: "5977", name: "Cosmetic Stores" },
        { code: "5978", name: "Typewriter Stores" },
        { code: "5992", name: "Florists" },
        { code: "5993", name: "Cigar Stores and Stands" },
        { code: "5994", name: "News Dealers and Newsstands" },
        { code: "5995", name: "Pet Shops and Pet Foods" },
        { code: "5996", name: "Swimming Pools, Sales, and Supplies" },
        { code: "5999", name: "Miscellaneous and Specialty Retail Stores" },
        { code: "6010", name: "Financial Institutions – Manual Cash Disbursements" },
        { code: "6011", name: "Financial Institutions – Automated Cash Disbursements" },
        { code: "6012", name: "Financial Institutions – Merchandise and Services" },
        { code: "6050", name: "Quasi Cash – Financial Institutions" },
        { code: "6051", name: "Quasi Cash – Merchant" },
        { code: "6211", name: "Securities – Brokers/Dealers" },
        { code: "7011", name: "Lodging – Hotels, Motels, and Resorts" },
        { code: "7021", name: "Timeshares" },
        { code: "7032", name: "Sporting and Recreational Camps" },
        { code: "7033", name: "Trailer Parks and Campgrounds" },
        { code: "7210", name: "Laundry, Cleaning, and Garment Services" },
        { code: "7216", name: "Dry Cleaners" },
        { code: "7217", name: "Carpet and Upholstery Cleaning" },
        { code: "7221", name: "Photographic Studios" },
        { code: "7230", name: "Beauty and Barber Shops" },
        { code: "7299", name: "Miscellaneous Personal Services" },
        { code: "7311", name: "Advertising Services" },
        { code: "7321", name: "Consumer Credit Reporting Agencies" },
        { code: "7333", name: "Commercial Photography and Art" },
        { code: "7338", name: "Quick Copy and Reprographic Services" },
        { code: "7339", name: "Stenographic and Secretarial Support Services" },
        { code: "7393", name: "Detective and Protective Services" },
        { code: "7394", name: "Equipment Rentals and Leasing Services" },
        { code: "7399", name: "Business Services Not Elsewhere Classified" },
        { code: "7512", name: "Car Rental Agencies" },
        { code: "7513", name: "Truck and Utility Trailer Rentals" },
        { code: "7519", name: "Motor Home and Recreational Vehicle Rentals" },
        { code: "7523", name: "Parking Lots and Garages" },
        { code: "7538", name: "Auto Body Repair Shops" },
        { code: "7539", name: "Automotive Repair Shops" },
        { code: "7542", name: "Car Washes" },
        { code: "7549", name: "Towing Services" },
        { code: "7622", name: "Electrical and Small Appliance Repair Shops" },
        { code: "7623", name: "Air Conditioning and Refrigeration Repair Shops" },
        { code: "7629", name: "Electrical and Electronic Repair Shops" },
        { code: "7631", name: "Watch, Clock, and Jewelry Repair Shops" },
        { code: "7641", name: "Furniture Repair and Refinishing" },
        { code: "7699", name: "Miscellaneous Repair Shops" },
        { code: "7829", name: "Motion Picture and Video Tape Production" },
        { code: "7832", name: "Motion Picture Theaters" },
        { code: "7841", name: "Video Tape Rental Stores" },
        { code: "7911", name: "Dance Halls, Studios, and Schools" },
        { code: "7922", name: "Theatrical Producers and Ticket Agencies" },
        { code: "7929", name: "Bands, Orchestras, and Other Entertainers" },
        { code: "7932", name: "Billiard and Pool Halls" },
        { code: "7933", name: "Bowling Alleys" },
        { code: "7941", name: "Commercial Sports, Professional Clubs" },
        { code: "7991", name: "Tourist Attractions and Exhibits" },
        { code: "7992", name: "Public Golf Courses" },
        { code: "7993", name: "Video Amusement Game Supplies" },
        { code: "7994", name: "Video Game Arcades" },
        { code: "7995", name: "Betting and Gambling" },
        { code: "7996", name: "Amusement Parks and Carnivals" },
        { code: "7997", name: "Clubs – Country Clubs and Memberships" },
        { code: "7998", name: "Aquariums, Zoos, and Botanical Gardens" },
        { code: "7999", name: "Recreation Services Not Elsewhere Classified" },
        { code: "8011", name: "Doctors and Physicians" },
        { code: "8021", name: "Dentists and Orthodontists" },
        { code: "8031", name: "Osteopaths" },
        { code: "8041", name: "Chiropractors" },
        { code: "8042", name: "Optometrists and Eye Glasses" },
        { code: "8043", name: "Opticians and Dispensing" },
        { code: "8044", name: "Optometrists" },
        { code: "8049", name: "Chiropodists and Podiatrists" },
        { code: "8050", name: "Nursing and Personal Care Facilities" },
        { code: "8062", name: "Hospitals" },
        { code: "8071", name: "Dental Laboratories" },
        { code: "8099", name: "Health Practitioners Not Elsewhere Classified" },
        { code: "8211", name: "Elementary and Secondary Schools" },
        { code: "8220", name: "Colleges, Universities, and Professional Schools" },
        { code: "8241", name: "Correspondence Schools" },
        { code: "8244", name: "Business and Secretarial Schools" },
        { code: "8249", name: "Vocational and Trade Schools" },
        { code: "8299", name: "Educational Services" },
        { code: "8398", name: "Charitable and Social Service Organizations" },
        { code: "8641", name: "Civic, Social, and Fraternal Associations" },
        { code: "8661", name: "Religious Organizations" },
        { code: "8675", name: "Automobile Associations" },
        { code: "8699", name: "Membership Organizations Not Elsewhere Classified" },
        { code: "8734", name: "Testing Laboratories" },
        { code: "8911", name: "Architectural, Engineering, and Surveying Services" },
        { code: "8931", name: "Accounting, Auditing, and Bookkeeping Services" },
        { code: "8999", name: "Professional Services Not Elsewhere Classified" },
        { code: "9211", name: "Court Costs and Legal Fees" },
        { code: "9222", name: "Fines" },
        { code: "9950", name: "Intra-Company Purchases" }
      ],
      showConfirmationModal: false,
      showPreviewModal: false,
      row:null,
      selectedIdType:'passport',
      loader: false,
      showBusinessForm: true,
      ownerRowList:[
        // {
        //   id:1
        // }
      ],
      websites:[
        {
          url:'https://dashboard.sandbox.checkout.com/',
        }
      ],
      dob:'',
      type:'',
      country:'',
      addressLine1:'',
      addressLine2:'',
      city:'',
      state:'',
      postalCode:'',
      phone:'',
      email:'',
      website:'',
      mcc:'',
      disableOwner:true,
      storeId:'',
      parentEntity:'',
      reference:'',
      ownerToDelete: null,
      indexForDelete: null,
      name:'',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },

    }
  },
  methods: {
    confirm() {
      let owner = this.ownerToDelete
      let index = this.indexForDelete

      if(owner.id == null){
        this.ownerRowList.splice(index, 1);
        this.showConfirmationModal = false
        return
      }

      let formattedDate = this.formatDate(owner.dob);

      let data = {
        firstName: owner.firstName,
        lastName: owner.lastName,
        dob: formattedDate,
        identityType: owner.idType,
        attachment: owner.documentFile,
        type:'delete',
        storeId: this.storeId,
        id: owner.id
      }

      this.$store.dispatch('exportExcelLoader',true)
      this.makeRequest('post', 'v1/manage-store-owners', data).then(callResponse => {

        this.$store.dispatch('exportExcelLoader',false)
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          let response = callResponse.response.data.data

          if (code == 200) {
            this.ownerRowList.splice(index, 1);
            this.showConfirmationModal = false
          }
        }

      });
    },
    denied() {
      this.ownerToDelete = null
      this.indexForDelete = null
      this.showConfirmationModal = false
    },
    enableOwnerTab(){
      this.disableOwner = false
      // Get the tabs and their panes
      const currentActiveTab = document.querySelector("#account-pill-general");
      const currentActivePane = document.querySelector("#account-vertical-general");
      const newTab = document.getElementById("account-pill-password");
      const newPane = document.getElementById("account-vertical-password");

      // Remove active classes from the currently active tab and tab pane
      if (currentActiveTab) currentActiveTab.classList.remove("active");
      if (currentActivePane) {
        currentActivePane.classList.remove("show", "active");
      }

      if (newTab){
        newTab.classList.add("active");
      }
      // Add active classes to the new tab and its corresponding pane
      if (newPane) newPane.classList.add("show", "active");
    },
    async submitAllForms() {

      this.$validator.validateAll().then(async valid => {
        if (valid) {
          const combinedData = {
            parentEntity: this.parentEntity,
            reference:  this.parentEntity,
            name: this.name,
            email: this.email,
            phone: this.phone,
            addressline1: this.addressLine1,
            addressline2: this.addressLine2,
            city: this.city,
            state: this.state,
            postCode: this.postalCode,
            country: this.country,
            website: this.website,
            type: this.type,
            mcc: this.mcc,
            storeId: this.storeId

          };

          this.$store.dispatch('exportExcelLoader',true)

          this.makeRequest('post', 'v1/update-store', combinedData, {}, false).then(callResponse => {
            this.$store.dispatch('exportExcelLoader',false)
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data
              if (code == 200) {
                this.enableOwnerTab()
              }
            }

          });
        }
      })
    },
    submitForApproval() {
      let data = {
        status: 1,
        storeId: this.storeId,
        id: this.storeId,
        parentEntity: this.$route.params.parentEntity,
        reference: this.$route.params.uniqueRef,
        name: this.name,
        email: this.email,
        phone: this.phone,
        addressline1: this.addressLine1,
        addressline2: this.addressLine2,
        city: this.city,
        state: this.state,
        postCode: this.postalCode,
        country: this.country,
        website: this.website,
        type: this.type,
        mcc: this.mcc
      }
      this.$store.dispatch('exportExcelLoader',true)
      this.makeRequest('post', 'v1/update-store', data, {}, false).then(callResponse => {
        if (!callResponse.error) {
          this.$store.dispatch('exportExcelLoader',false)
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.$router.push({name: 'manage-stores'});
          }
        }

      });
    },
    addOwnerRow() {
      this.ownerRowList.push({
        rowIdentifier: `owner-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        id: null,
        firstName: '',
        middleName: '',
        lastName: '',
        dob: null,
        idType: 'passport',
        status: 'add',
      });
    },
    handleFileUpload(event, owner) {
      const file = event.target.files[0];
      if (file && typeof (file) != 'undefined') {
        this.getBase64(file).then( (response) => {
              owner.documentFile = response
              owner.doc_url = response
            }
        )
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async submitOwner(owner, index) {
      try {

        let formattedDate = this.formatDate(owner.dob) ;

        let data = {
          firstName: owner.firstName,
          lastName: owner.lastName,
          dob: formattedDate,
          identityType: owner.idType,
          attachment: owner.documentFile,
          type:owner.status, // add/update
          storeId: this.storeId
        }

        if(owner.status == 'update'){
          data.id = owner.id
        }

        this.$store.dispatch('exportExcelLoader',true)
        this.makeRequest('post', 'v1/manage-store-owners', data).then(callResponse => {

          this.$store.dispatch('exportExcelLoader',false)
          if (!callResponse.error) {
            let code = callResponse.response.data.code;

            let response = callResponse.response.data.data

            if (code == 200) {
              // this.$set(this.ownerRowList, index, {
              //   ...owner,
              //   id: response.id,
              //   status: 'update',
              // });

              let updatedValues = {
                id: response.id,
                status: 'update',
              }

              this.ownerRowList[index] = { ...this.ownerRowList[index], ...updatedValues };
            }
          }

        });


      } catch (error) {
        console.error('Error submitting owner:', error);
      }
    },
    deleteOwnerRow(owner,index) {
      this.ownerToDelete = owner
      this.indexForDelete = index
      this.showConfirmationModal = true
    },
    addWebsite(){
      this.websites.push({
        url:'',
      })
    },
    formatStringInHumanReadable(str ){
      return str.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()).trim()
    },
  },
}
</script>


<!--<style>-->
<!--.preview-image {-->
<!--  width: 300px;-->
<!--  height: auto;-->
<!--  cursor: pointer;-->
<!--  transition: transform 0.3s ease;-->
<!--}-->

<!--.preview-image:hover {-->
<!--  transform: scale(1.1);-->
<!--}-->




<!--.enlarged-image {-->
<!--  position: absolute;-->
<!--  top: calc(50%);-->
<!--  left: calc(50%);-->
<!--  transform: translate(-50%, -50%);-->
<!--  max-width: 100%;-->
<!--  max-height: 100vh; /* Ensure it fits within the viewport */-->
<!--  object-fit: contain;-->
<!--}-->



<!--</style>-->


<style>
/* Style for the small preview image */
.preview-image {
  width: 300px;
  height: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.preview-image:hover {
  transform: scale(1.02);
}

/* Fullscreen modal styling */
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  cursor: pointer;
}

/* Remove background and make the image larger */
.fullscreen-modal::before {
  content: "";
  display: none; /* Remove the modal backdrop */
}

.fullscreen-image {
  position: relative;
  max-width: 60vh; /* Allow the image to grow larger */
  max-height: 60vh; /* Fit within the viewport */
  object-fit: contain;
  transition: transform 0.3s ease;
  transform: scale(1.5);
}

.fullscreen-image:hover {
  //transform: scale(1.05);
}
</style>


